import React, { useEffect, useRef } from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useAuth } from '../../hooks/useAuth';
import { verifiedSuccessText } from '../../utils/signInActionCopy';

// Keycloak initialisation failed (the sign-in service did not respond, or the token exchange was
// refused). A setup the app verified is kept, so the user is not led to add the method again.
const SignInFailed: React.FC<{ productName: string }> = ({ productName }) => {
  const { actionOutcome, login } = useAuth();
  const heading = useRef<HTMLHeadingElement>(null);
  const kept = verifiedSuccessText(actionOutcome);

  useEffect(() => {
    document.title = `Sign-in failed - ${productName}`;
    heading.current?.focus();
  }, [productName]);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" px={2}>
      <Paper sx={{ p: 4, maxWidth: 440, width: '100%', textAlign: 'center' }}>
        <Typography component="h1" variant="h6" tabIndex={-1} ref={heading} sx={{ mb: 1, outline: 'none' }}>
          {`We couldn't sign you in to ${productName}.`}
        </Typography>
        {/* Straight after the focused heading, so reading on from it reaches the kept success. */}
        {kept && (
          <Typography variant="body1" sx={{ mb: 1 }}>
            {kept}
          </Typography>
        )}
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Try signing in again.
        </Typography>
        <Button variant="contained" onClick={() => login(window.location.href)}>
          Sign in again
        </Button>
      </Paper>
    </Box>
  );
};

export default SignInFailed;
